export { default as DadosTabela } from './DadosTabela';
export { default as ResumoAtivo } from './ResumoAtivo';
export { default as FormularioSimulacao } from './FormularioSimulacao';
export { default as ResultadoSimulacao } from './ResultadoSimulacao';
export { default as TabelaSAC } from './TabelaSAC';
export { default as PainelAntecipacao } from './PainelAntecipacao';
export { default as AvisoIndisponivel } from './AvisoIndisponivel';
// DisclaimerSimulador removido a pedido
export { default as SelecaoAtivo } from './SelecaoAtivo';
export { default as ParcelasCondicionantes } from './ParcelasCondicionantes';
export { default as ParcelasIntermediariasManual } from './ParcelasIntermediariasManual';
export { default as ResumoVenda } from './ResumoVenda';
export { default as CardMobile } from './CardMobile';
export { default as PagamentosSinalGravarVenda } from './PagamentosSinalGravarVenda';
export { default as PagamentosSinalSplit } from './PagamentosSinalSplit';
export { default as CondicoesEspeciaisCompleto } from './CondicoesEspeciaisCompleto';
export { default as AdminCampos } from './AdminCampos';
export { default as CondicoesEspeciaisExtras } from './CondicoesEspeciaisExtras';
export { default as Autorizacao } from './Autorizacao';
export { default as ModalGerarVenda } from './ModalGerarVenda';

// Componentes legados (não mais usados na UI principal — preservados pra
// histórico e possível reuso. Podem ser removidos após avaliação final):
// - PagamentosSinal (form simples calculadora; substituído por PagamentosSinalGravarVenda)
// - SeletorContexto (substituído pelo flow integrado dentro de ModalGerarVenda)
// - BotaoGerarVenda (substituído pelo botão inline em index.js + ModalGerarVenda)
